<template>
  <div v-loading.body="loading">
    <header-tabs :active="$route.path"></header-tabs>
    <el-row class="filter">
      <el-col>
        <div
          style="background: #f3f3f3;height: 30px;line-height:30px;padding: 0 25px;display: flex; align-items: center;"
        >
          <div>筛选查询</div>
          <el-button
            type="text"
            style="margin-left: auto;"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px;">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-input
                    v-model="form.keyword"
                    placeholder="用户id"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="border: 1px solid #ddd;">
        <div
          style="background: #f3f3f3;height: 50px;line-height:30px;padding: 0 25px;display: flex; align-items:center;"
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto;"
            type="success"
            size="mini"
            @click="edit()"
            >添加</el-button
          >
        </div>
        <div v-if="resData" style="margin-bottom: 0;">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.data"
            tooltip-effect="dark"
          >
            <el-table-column
              prop="alter_label_setting_id"
              label="序号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="sort_no"
              label="汇总编号"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="hg_name"
              label="中分位"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="user_format"
              width="900"
              label="用户id"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="admin_name"
              label="更新人"
              width="100"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="update_time"
              label="更新时间"
              width="180"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>

            <el-table-column label="操作" prop="goods_name" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" @click="edit(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right;padding: 25px;">
          <el-pagination
            :current-page.sync="currentPage"
            background
            layout="total, prev, pager, next, jumper, sizes "
            :total="resData.total"
            :page-size="resData.per_page"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>

        <el-dialog title="添加" :visible.sync="add_dialogForm" width="35%">
          <template>
            <div style="float: right;margin-right: 140px">
              <span>中分位:</span>
              <el-select v-model="form.hgd_id" filterable>
                <el-option
                  v-for="item in hg_detail"
                  :key="item.hgd_id"
                  :value="item.hgd_id"
                  :label="item.hg_name"
                ></el-option>
              </el-select>
            </div>
            <div style="margin-top: 50px">
              <el-transfer
                v-model="form.add_transfer_value"
                filterable
                :titles="['选项', '选中']"
                filter-placeholder="请输入用户id"
                :data="add_transfer_data"
              >
              </el-transfer>
            </div>
          </template>
          <div slot="footer" class="dialog-footer">
            <el-button @click="add_dialogForm = false">取 消</el-button>
            <el-button type="primary" @click="editSave()">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="编辑" :visible.sync="edit_dialogForm" width="35%">
          <div
            style="font-size:16px;font-weight:800;margin-bottom:20px;margin-top:-20px"
          >
            汇总编号: {{ editing_group }}
          </div>
          <template>
            <div style="float: right;margin-right: 140px">
              <span>中分位:</span>
              <el-select v-model="form.hgd_id" filterable>
                <el-option
                  v-for="item in hg_detail"
                  :key="item.hgd_id"
                  :value="item.hgd_id"
                  :label="item.hg_name"
                ></el-option>
              </el-select>
            </div>
            <div style="margin-top: 80px">
              <el-transfer
                v-model="form.edit_transfer_value"
                filterable
                :titles="['选项', '选中']"
                filter-placeholder="请输入用户名"
                :data="edit_transfer_data"
              >
              </el-transfer>
            </div>
          </template>
          <div slot="footer" class="dialog-footer">
            <el-button @click="edit_dialogForm = false">取 消</el-button>
            <el-button type="primary" @click="editSave()">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Global_ from "../../components/Global";
import HeaderTabs from "./components/HeaderTabs";
export default {
  components: { HeaderTabs },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData();
    });
  },
  data() {
    return {
      resData: null,
      form: {
        hgd_id: "",
        add_transfer_value: [],
        edit_transfer_value: [],
        alter_label_setting_id: 0,
      },
      loading: false,
      url: "/erp/WavePickingTempSummary/labelUserSettingList",
      currentPage: 1,
      tableLoading: false,
      filterFold: false,
      edit_dialogForm: false,
      add_dialogForm: false,
      edit_transfer_data: [],
      add_transfer_data: [],
      editing_group: 0, // 正在编辑的分组
      hg_detail: [],
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    handleSizeChange(e) {
      this.form.page_size = e;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.form).then(res => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          this.currentPage = parseInt(this.resData.current_page);
          this.add_transfer_data = this.resData.user_data;
          this.hg_detail = this.resData.hg_detail;
        }
      });
    },
    onSubmit() {
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then(res => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
        }
      });
    },
    search() {
      this.form.page = 1;
      this.fetchData();
    },
    buildData(key_label_data) {
      const data = [];
      for (let i in key_label_data) {
        data.push({
          label: "" + key_label_data[i]["key"] + "",
          key: key_label_data[i]["key"],
        });
      }
      return data;
    },
    edit(val) {
      if (val) {
        this.editing_group = val.sort_no;
        this.form.alter_label_setting_id = val.alter_label_setting_id;
        this.$http
          .get(
            "/erp/WavePickingTempSummary/labelUserSetting?alter_label_setting_id=" +
              val.alter_label_setting_id,
          )
          .then(res => {
            setTimeout(() => {
              this.loading = false;
            }, 200);
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.form.edit_transfer_value = res.data.data.edit_data;
              this.edit_transfer_data = this.buildData(res.data.data.user_data);
              if (res.data.data.hgd_id != 0) {
                this.$set(this.form, "hgd_id", res.data.data.hgd_id);
              }
              this.edit_dialogForm = true;
            }
          });
      } else {
        this.$http.post(this.url, this.filteredForm).then(res => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData = res.data.data;
            this.currentPage = parseInt(this.resData.current_page);
            this.add_transfer_data = this.buildData(this.resData.user_data);
            this.form.alter_label_setting_id = 0;
            this.$set(this.form, "hgd_id", "");
            this.add_dialogForm = true;
          }
        });
      }
    },
    editSave() {
      this.$http
        .post("/erp/WavePickingTempSummary/labelUserSetting", this.filteredForm)
        .then(res => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success("保存成功");
            this.add_dialogForm = false;
            this.edit_dialogForm = false;
            this.$http.post(this.url, this.filteredForm).then(res => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                this.resData = res.data.data;
                this.currentPage = parseInt(this.resData.current_page);
                this.add_transfer_data = this.buildData(this.resData.user_data);
                this.form.alter_label_setting_id = 0;
              }
            });
            this.restForm();
          }
        });
    },
    restForm() {
      this.form.add_transfer_value = [];
      this.form.edit_transfer_value = [];
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/wavepicking/LabelUserSetting.vue